<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo d-flex align-items-center">
        <vuexy-logo />
        <h2
          v-if="!appConfig.logo_only"
          class="brand-text text-primary ml-1 mb-0"
        >
          {{ appConfig.brand }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        xl="8"
        lg="6"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
        xl="4"
        lg="6"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- <b-card-title class="mb-1"> Adventure starts here 🚀 </b-card-title> -->
          <b-card-title class="text-success text-center text-bold">
            {{ $t('Register Note',{brand:appConfig.brand}) }}
          </b-card-title>

          <!-- form -->
          <validation-observer
            ref="registerForm"
            #default="{ invalid }"
          >
            <b-form
              class="auth-register-form mt-2"
              @submit.stop.prevent="onSubmit"
            >
              <div v-if="step === 1">
                <!-- name -->
                <b-form-group
                  :label="$t('FullName')"
                  label-for="register-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                    vid="name"
                    rules="required|min:3"
                  >
                    <b-form-input
                      id="register-name"
                      v-model="form.name"
                      name="register-name"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('FullName')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- mobile -->
                <b-form-group
                  :label="$t('Mobile')"
                  label-for="register-mobile"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Mobile')"
                    vid="mobile"
                    rules="required"
                  >
                    <vue-phone-number-input
                      v-model="mobile"
                      style="direction:ltr"
                      default-country-code="IR"
                      name="mobile"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Mobile')"
                      :translations="{
                        countrySelectorLabel: $t('Country Code'),
                        countrySelectorError: $t('Choose a country'),
                        phoneNumberLabel: $t('Mobile'),
                        example: $t('Example')+' :'
                      }"
                      :dark="$store.state.appConfig.layout.skin === 'dark'"
                      dark-color="#283046"
                      @update="updateMobil"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- password -->
                <b-form-group
                  label-for="register-password"
                  :label="$t('Password')"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="register-password"
                        v-model="form.password"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        :state="errors.length > 0 ? false : null"
                        name="register-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIcon"
                          class="cursor-pointer"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- affiliate code -->
                <b-form-group
                  :label="$t('Affiliate code')"
                  label-for="affiliate-code"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="affiliate-code"
                    vid="affiliate-code"
                  >
                    <b-form-input
                      id="affiliate-code"
                      v-model="form.affiliate_code"
                      name="affiliate-code"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Affiliate code')"
                      :disabled="affiliateCode.toString().length !== 0"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-checkbox
                      id="register-privacy-policy"
                      v-model="form.status"
                      name="checkbox-1"
                    >
                      {{ $t('agree1') }}
                      <b-link
                        target="_blank"
                        href="https://autochat.ir/%d9%82%d9%88%d8%a7%d9%86%db%8c%d9%86-%d9%88-%d9%85%d9%82%d8%b1%d8%b1%d8%a7%d8%aa/"
                      >
                        {{ $t('policy') }}
                      </b-link>
                      {{ $t('agree2') }}
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  variant="primary"
                  block
                  type="submit"
                  :disabled="invalid || spin"
                >
                  {{ $t('Sign up') }}
                  <b-spinner
                    v-if="spin"
                    small
                  />
                </b-button>
              </div>
              <!--end::step 1 register form-->
              <!--begin::step 2 register form-->
              <div v-else>
                <div
                  class="text-muted my-2"
                >
                  {{ $t("Verify mobile number") }}
                </div>
                <div
                  class="d-flex justify-content-center"
                >
                  <h2
                    style="direction: ltr"
                  >
                    {{ fullMobile }}
                  </h2>
                </div>
                <b-form-group
                  class="required"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Enter code')"
                    rules="required|integer|length:6"
                  >
                    <b-form-input
                      id="code"
                      v-model="form.code"
                      name="code"
                      placeholder="123456"
                      class="verify-code-input text-center h-auto"
                      maxlength="6"
                      autocomplete="off"
                    />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </b-form-group>
                <b-button
                  ref="formSubmit"
                  type="submit"
                  variant="primary"
                  class="font-weight-bold full-width"
                  :disabled="invalid || spin"
                >
                  <b-spinner
                    v-if="spin"
                    small
                  />
                  {{ $t("Verify button") }}
                </b-button>
                <div class="text-muted font-weight-bold mt-2">
                  {{ $t("Not receive code") }}
                  <b-button
                    variant="transparent"
                    class="text-primary text-hover-primary font-weight-extra-bold px-0"
                    @click="preRegister"
                  >
                    {{ $t("Resend code") }}
                  </b-button>
                  {{ $t("Or with us") }}
                  <router-link
                    class="text-primary text-hover-primary font-weight-extra-bold"
                    to="/contact-us"
                  >
                    {{
                      $t("Contact us")
                    }}
                  </router-link>
                </div>
              </div>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>{{ $t('Already have') }}</span>
            <b-link :to="{ name: 'auth-login' }">
              <span>&nbsp;{{ $t('Sign in instead') }}</span>
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BSpinner,
  BCardTitle, VBTooltip,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'

import { required, min } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser, permissionsResolver } from '../../../auth/utils'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BSpinner,
    BForm,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  props: {
    affiliateCode: {
      type: [String, Number],
      default: () => '',
    },
  },
  data() {
    return {
      step: 1,
      form: {
        name: '',
        mobile: '',
        password: '',
        code: '',
        hashed_code: '',
        status: '',
        affiliate_code: '',
      },
      mobile: '',
      fullMobile: '',
      spin: false,
      sideImg: require('@/assets/images/pages/auth-v1.svg'),
      // validation rules
      required,
    }
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/auth-v1-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  watch: {
    'form.code': 'autoSubmit',
  },
  created() {
    if (this.affiliateCode) {
      this.form.affiliate_code = this.affiliateCode
    }
  },
  methods: {
    resetForm() {
      this.form = {
        first_name: '',
        mobile: '',
        password: '',
        code: '',
      }
      this.mobile = ''
      this.validMobile = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    onSubmit() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          if (this.step === 1) {
            this.preRegister(false)
          } else {
            this.register()
          }
        }
      })
    },
    preRegister(resend = true) {
      // set spinner to submit button
      if (!resend) this.spin = true
      // send pre register request
      if (this.validMobile) {
        this.$http.post('verify', this.form).then(({ data }) => {
          this.spin = false
          this.form.hashed_code = data.token
          if (!resend) this.step = 2
        }).catch(() => {
          if (!resend) this.spin = false
        })
      } else {
        this.spin = false
        this.showErrorNotification(this.$t('check form data'))
      }
    },
    register() {
      this.spin = true
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          this.$http
            .post('register', this.form)
            .then(({ data }) => {
              const {
                user,
              } = data
              useJwt.setToken(data.access_token)
              useJwt.setRefreshToken(data.refresh_token)
              localStorage.setItem('userData', JSON.stringify(user))
              const permissions = permissionsResolver(user.permissions)
              permissions.push([
                {
                  action: 'manage',
                  subject: 'all',
                },
              ])
              this.$ability.update(permissions)
              this.$router
                .replace(getHomeRouteForLoggedInUser(user.role))
                .then(() => {
                  this.$gtm.trackEvent({
                    event: 'signup',
                    plan: 'free',
                    moaref: this.affiliateCode,
                  })
                  this.showSuccessNotification(`${this.$t('Welcome')} ${user.name}`)
                })
            })
            .catch(() => {
              this.spin = false
            })
        }
      })
    },
    autoSubmit(code) {
      if (code && code.length >= 6) this.register()
    },
    backStep() {
      this.step = 1
    },
    updateMobil(e) {
      this.validMobile = e.isValid
      if (e.isValid) {
        this.form.mobile = e.e164
        this.fullMobile = e.formatInternational
      }
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@core/scss/vue/pages/page-auth.scss";

</style>
